module.exports = __webpack_public_path__ + "static/00097.5c27af13.jpg";